<template>

  <div class="disableScreen" v-if="showModal && tipo != 'warning' && tipo != 'withAccLink'">

    <div class="errIconMsg">
      <div class="centered">

        <div v-if="tipo == 'error'">
          <svg width="122" height="112" viewBox="0 0 122 112" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="fillIcon" fill-rule="evenodd" clip-rule="evenodd" d="M78.8576 11.7752C75.2064 5.38249 68.3959 1.40884 61.0267 1.40013C53.6591 1.39142 46.845 5.34658 43.1449 11.7792L4.27633 78.8848C0.502174 85.2938 0.413843 93.3332 4.07479 99.8923C7.73657 106.453 14.5924 110.536 22.0503 110.6C22.052 110.6 22.0486 110.6 22.0503 110.6L99.8819 110.6C107.427 110.523 114.268 106.449 117.927 99.8982C121.584 93.3498 121.503 85.3282 117.712 78.8571L117.709 78.8512L78.8576 11.7752ZM99.889 112L22.0441 112C14.088 111.934 6.77353 107.579 2.86712 100.58C-1.03606 93.5868 -0.944896 85.0121 3.08476 78.1691L41.9462 11.0759C45.8947 4.2113 53.1663 -0.00927925 61.0283 1.53198e-05C68.8895 0.00930889 76.1585 4.24738 80.0585 11.0756L118.906 78.1443C122.948 85.0461 123.035 93.6018 119.134 100.586C115.228 107.579 107.928 111.921 99.889 112ZM22.0893 100.799C18.1487 100.766 14.4849 98.5847 12.5286 95.0796C10.5744 91.5784 10.62 87.2857 12.6375 83.8596L51.5277 16.7169C53.4972 13.2929 57.1094 11.1963 61.0153 11.2009C64.9208 11.2056 68.5317 13.3108 70.4685 16.7018L109.346 83.8235C111.384 87.3027 111.428 91.586 109.474 95.0828C107.518 98.5847 103.862 100.76 99.8349 100.799L22.0893 100.799ZM110.542 83.1152C110.543 83.1168 110.541 83.1137 110.542 83.1152C112.829 87.0228 112.879 91.8378 110.682 95.7708C108.48 99.7125 104.366 102.155 99.8484 102.199L99.8349 102.2L22.0779 102.199C17.6381 102.162 13.5195 99.7063 11.3209 95.7671C9.12532 91.8335 9.1729 87.0078 11.4433 83.1484C11.4442 83.1469 11.4424 83.1499 11.4433 83.1484L50.329 16.0136C50.3295 16.0126 50.3284 16.0145 50.329 16.0136C52.5468 12.1603 56.6166 9.79562 61.0169 9.80082C65.4129 9.80602 69.4811 12.1741 71.6673 15.9986C71.668 15.9998 71.6666 15.9974 71.6673 15.9986L110.542 83.1152ZM61.0054 88.198C63.3038 88.198 65.1662 86.317 65.1662 83.9977C65.1662 81.6783 63.3038 79.7973 61.0054 79.7973C58.707 79.7973 56.8446 81.6783 56.8446 83.9977C56.8446 86.317 58.707 88.198 61.0054 88.198ZM65.1826 34.9936H56.8609V71.3966H65.1826V34.9936ZM66.5526 83.9977C66.5526 87.0907 64.069 89.5981 61.0054 89.5981C57.9418 89.5981 55.4582 87.0907 55.4582 83.9977C55.4582 80.9046 57.9418 78.3972 61.0054 78.3972C64.069 78.3972 66.5526 80.9046 66.5526 83.9977ZM66.5689 33.5935V72.7968H55.4746V33.5935H66.5689Z"/>
          </svg>
        </div>

        <div v-if="tipo == 'info'">
          <svg width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.1897 29.1237C44.3925 26.5081 47.0587 24.8807 49.9348 25.0068V25.0224C53.7911 25.1581 56.815 28.3809 56.7054 32.2382C56.6424 35.1166 54.8436 37.6704 52.1548 38.699C49.466 39.7275 46.4221 39.0261 44.4545 36.9246C42.4868 34.823 41.9868 31.7394 43.1897 29.1237Z" fill="#ED1846"/>
            <path d="M41.4065 42.7166H53.9709C54.5334 42.667 55.0925 42.8426 55.5223 43.2038C55.952 43.5651 56.2162 44.0815 56.2554 44.6369C56.4581 45.6415 56.2536 46.5925 56.0491 47.5438C55.9991 47.7765 55.9491 48.0092 55.905 48.2427C55.0828 52.5806 54.2723 56.9163 53.4734 61.2497C53.3868 61.7174 53.2965 62.1851 53.2061 62.6532C52.9895 63.7751 52.7726 64.8989 52.6045 66.0297C52.5284 66.6786 52.5496 67.3349 52.6675 67.9777C52.7144 68.5529 53.0149 69.079 53.4896 69.4167C53.9644 69.7544 54.5656 69.8697 55.1342 69.7322C55.8392 69.5744 56.5252 69.3428 57.1804 69.0414C57.4173 68.9392 57.6455 68.8111 57.8734 68.6832C58.1847 68.5084 58.4954 68.334 58.8271 68.2263C59.1928 68.0974 59.5982 68.1407 59.9273 68.3438C60.1997 68.709 60.3063 69.1692 60.2216 69.6148C60.0483 70.1248 59.747 70.5834 59.3457 70.9479C57.1362 73.263 54.0561 74.5774 50.8316 74.5813C49.3269 74.5987 47.823 74.504 46.3328 74.2981C43.8171 73.8837 40.6497 70.7407 41.2033 67.3905C41.3874 66.283 41.5604 65.1741 41.7335 64.065C41.9489 62.6839 42.1645 61.3026 42.4015 59.9234C42.6281 58.5984 42.8682 57.2761 43.1082 55.9542C43.5364 53.5961 43.9644 51.2393 44.3146 48.8712C44.6089 46.8957 43.8241 46.0529 41.876 45.9632C41.1355 45.8989 40.4121 45.7072 39.7387 45.3967C39.1855 45.1531 38.8899 44.5529 39.0379 43.9738C39.1175 43.4407 39.526 43.0132 40.061 42.9031C40.4994 42.7834 40.9517 42.7207 41.4065 42.7166Z" fill="#ED1846"/>
            <circle cx="49.5" cy="49.5" r="48.5" stroke="#ED1846" stroke-width="2"/>
            <circle cx="49.5" cy="49.5" r="41.5" stroke="#ED1846" stroke-width="2"/>
          </svg>
        </div>

        {{messageErr}}

      </div>
    </div>
    <div class="errDetail">
      <div class="centered">

        <div>
          {{detailErr}}
          <div class="okButtonNoConsentDiv" v-if="showOkButton">
            <Okbutton 
              class="okButtonNoConsent"
              rotulo="Ok"
              tipo="submit"
              :confirmacao="false"
              @click="makeAction()"
            />
          </div>
        </div>

        <div class="space"></div>
      </div>
    </div>

  </div>

  <div class="disableScreen" v-if="showModal && tipo == 'warning'">

    <div class="errIconMsg2">
      <div class="centered">
      </div>
    </div>
    <div class="errDetail2">
      <div>
        <div class="space2"></div>
        <div class="errIconMsgFont">{{messageErr}}</div>
        <div class="space2"></div>
        <div style="margin-bottom: 20px; color: var(--exceptions-text-color)">{{detailErr}}</div>
        <Okbutton
          rotulo="Ok"
          tipo="submit"
          :confirmacao="false"
          @botaoAtivado="disable()"
        />
      </div>
    </div>

  </div>

  <div class="disableScreen" v-if="showModal && tipo == 'withAccLink'">

    <div class="errIconMsg">
      <div class="centered">
          <div>
            <svg width="122" height="112" viewBox="0 0 122 112" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path :fill="fillIcon" fill-rule="evenodd" clip-rule="evenodd" d="M78.8576 11.7752C75.2064 5.38249 68.3959 1.40884 61.0267 1.40013C53.6591 1.39142 46.845 5.34658 43.1449 11.7792L4.27633 78.8848C0.502174 85.2938 0.413843 93.3332 4.07479 99.8923C7.73657 106.453 14.5924 110.536 22.0503 110.6C22.052 110.6 22.0486 110.6 22.0503 110.6L99.8819 110.6C107.427 110.523 114.268 106.449 117.927 99.8982C121.584 93.3498 121.503 85.3282 117.712 78.8571L117.709 78.8512L78.8576 11.7752ZM99.889 112L22.0441 112C14.088 111.934 6.77353 107.579 2.86712 100.58C-1.03606 93.5868 -0.944896 85.0121 3.08476 78.1691L41.9462 11.0759C45.8947 4.2113 53.1663 -0.00927925 61.0283 1.53198e-05C68.8895 0.00930889 76.1585 4.24738 80.0585 11.0756L118.906 78.1443C122.948 85.0461 123.035 93.6018 119.134 100.586C115.228 107.579 107.928 111.921 99.889 112ZM22.0893 100.799C18.1487 100.766 14.4849 98.5847 12.5286 95.0796C10.5744 91.5784 10.62 87.2857 12.6375 83.8596L51.5277 16.7169C53.4972 13.2929 57.1094 11.1963 61.0153 11.2009C64.9208 11.2056 68.5317 13.3108 70.4685 16.7018L109.346 83.8235C111.384 87.3027 111.428 91.586 109.474 95.0828C107.518 98.5847 103.862 100.76 99.8349 100.799L22.0893 100.799ZM110.542 83.1152C110.543 83.1168 110.541 83.1137 110.542 83.1152C112.829 87.0228 112.879 91.8378 110.682 95.7708C108.48 99.7125 104.366 102.155 99.8484 102.199L99.8349 102.2L22.0779 102.199C17.6381 102.162 13.5195 99.7063 11.3209 95.7671C9.12532 91.8335 9.1729 87.0078 11.4433 83.1484C11.4442 83.1469 11.4424 83.1499 11.4433 83.1484L50.329 16.0136C50.3295 16.0126 50.3284 16.0145 50.329 16.0136C52.5468 12.1603 56.6166 9.79562 61.0169 9.80082C65.4129 9.80602 69.4811 12.1741 71.6673 15.9986C71.668 15.9998 71.6666 15.9974 71.6673 15.9986L110.542 83.1152ZM61.0054 88.198C63.3038 88.198 65.1662 86.317 65.1662 83.9977C65.1662 81.6783 63.3038 79.7973 61.0054 79.7973C58.707 79.7973 56.8446 81.6783 56.8446 83.9977C56.8446 86.317 58.707 88.198 61.0054 88.198ZM65.1826 34.9936H56.8609V71.3966H65.1826V34.9936ZM66.5526 83.9977C66.5526 87.0907 64.069 89.5981 61.0054 89.5981C57.9418 89.5981 55.4582 87.0907 55.4582 83.9977C55.4582 80.9046 57.9418 78.3972 61.0054 78.3972C64.069 78.3972 66.5526 80.9046 66.5526 83.9977ZM66.5689 33.5935V72.7968H55.4746V33.5935H66.5689Z"/>
            </svg>
          </div>
          {{messageErr}}
      </div>
    </div>
    
    <div class="errDetailNoBorder">
      <div class="centered">
        <div>{{detailErr}}</div>
        <div style="margin-top: 2%;">
          <svg style="vertical-align: middle;" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="fillAccIcon" fill-rule="evenodd" clip-rule="evenodd" d="M9.85657 7.33797C10.3747 6.63976 10.5605 5.90391 9.9745 5.25438C8.65955 3.4144 7.77521 2.27657 7.22051 1.72861C6.16595 0.686876 4.43118 0.827787 3.51785 1.72772C3.0273 2.21108 2.86122 2.37707 2.35753 2.88868C-0.448123 5.69584 1.26291 11.6301 5.81145 16.1831C10.359 20.7351 16.2926 22.447 19.1042 19.6339C19.569 19.1858 19.9625 18.7921 20.2729 18.4641C21.1679 17.518 21.3038 15.8598 20.267 14.7825C19.7354 14.2302 18.6504 13.3885 16.733 12.017C16.1457 11.4919 15.4495 11.6057 14.8111 12.0245C14.504 12.226 14.2806 12.4298 13.8586 12.8521L13.0924 13.6188C12.9914 13.7198 11.621 13.0335 10.2908 11.7019C8.95978 10.3696 8.27396 8.99913 8.37441 8.89869L9.14118 8.1315C9.27506 7.99749 9.33906 7.93261 9.42114 7.84634C9.59215 7.66661 9.73374 7.50351 9.85657 7.33797ZM14.5058 15.033L15.2722 14.2662C15.5044 14.0337 15.6549 13.8908 15.7774 13.7923C17.457 14.9985 18.4298 15.7569 18.8271 16.1698C19.0657 16.4176 19.0286 16.8699 18.8212 17.0891C18.5342 17.3925 18.1614 17.7655 17.7038 18.2069C15.8858 20.0257 11.096 18.6438 7.22519 14.7692C3.35321 10.8934 1.97194 6.10286 3.77626 4.29756C4.27792 3.78805 4.43686 3.62919 4.92042 3.15273C5.10172 2.97408 5.59558 2.93396 5.81614 3.15184C6.2432 3.57371 7.0354 4.58806 8.20077 6.2114C8.14044 6.2863 8.06509 6.37094 7.97339 6.46732C7.90609 6.53805 7.85002 6.59489 7.72744 6.71759L6.96142 7.48403C5.65827 8.78707 6.76808 11.0048 8.87703 13.1158C10.9845 15.2254 13.2031 16.3364 14.5058 15.033Z"/>
            <path :fill="fillAccIcon" fill-rule="evenodd" clip-rule="evenodd" d="M16.0122 10.156C15.4736 6.74463 13.0231 6 12 6V4C13.7839 4 17.2632 5.25537 17.9878 9.84404L16.0122 10.156Z"/>
            <path :fill="fillAccIcon" fill-rule="evenodd" clip-rule="evenodd" d="M20.0122 10.156C18.9683 3.54463 14.1459 2 12 2V0C14.9067 0 20.758 2.05537 21.9878 9.84404L20.0122 10.156Z"/>
          </svg>
          <span style="vertical-align: middle;" class="semiLink" @click="redirectToContactUs()">{{detailErr2}}</span>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  props: {
    tipo: String,
    messageErr: String,
    detailErr: String,
    detailErr2: String,
    showOkButton: Boolean,
    okButtonAction: Function
  },
  data() {
    return {
      showModal: false,
      fillIcon: 'var(--exceptions-icons-color)',
      fillAccIcon: 'var(--exceptions-text-color)'
    }
  },
  methods: {
    enable(){
      this.showModal = true;
    },
    disable(){
      this.showModal = false;
    },
    redirectToContactUs(){
      this.$router.push({ name: 'contactUs' });
    },
    makeAction(){
      this.$emit('okButtonAction');
    },
  }
}
</script>

<style scoped>
.disableScreen{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--exceptions-backgroundup-transparency-color);
}
.errIconMsg, .errIconMsg2, .errDetail, .errDetail2, .errDetailNoBorder{
  text-align: center;
  width: 100%;
}
.errIconMsg{
  height: 60%;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  color: var(--exceptions-title-color);
}
.errIconMsg2{
  height: 40%;
}
.errIconMsgFont {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  color: var(--exceptions-title-color);
}
.errDetail, .errDetail2{
  font-size: 18px;
  line-height: 24px;
  color: var(--exceptions-text-color);
  background-color: var(--exceptions-backgrounddown-solid-color);
  border-radius: 40px 40px 0px 0px;
  border-top: 0.5px solid var(--exceptions-icons-color);
}
.errDetailNoBorder{
  font-size: 18px;
  line-height: 24px;
  color: var(--exceptions-text-color);
}
.errDetail{
  height: 40%;
}
.errDetail2{
  height: 60%;
}
.centered{
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.okButtonNoConsentDiv{
  margin-top: 15px;
}
.okButtonNoConsent{
  margin: auto;
  text-align: center;
}
.semiLink{
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 7px;
}
.space{
  padding: none;
  margin: none;
  height: 40%;
}
.space2{
  padding: none;
  margin: none;
  height: 40px;
}
</style>